import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  results: {},
  total: 0,
  terms: '',
  sort: [{lastUpdatedTime: {order: 'desc'}}],
  _source: {},
  from: 0,
  size: 50,
  query: {},
  filter: {},
  aggs: {},
  aggregations: {},
  indexList: {},
  libraryList: {},
  privateLibraryList: {},
  publicLibraryList: {},
  pageNumber: 1,
  isResetSelectedItems: false,
  libraryPositionMapping: {},
  departmentMap: {},
  divisionMap: {},
  subjectMap: {},
  instructorMap: {},
  majorMap: {},
  unitMap: {},
  startTimeMap: {},
  endTimeMap: {},
  blockMap: {},
  levelMap: {},
  courseSearches: [],
  shouldShowDropDown: false,
  courseFlags: [],
  lastUpdatedTime: {},
  selectedIndexes: [],
  matchAllInTags: [],
  matchAtLeastOneInTags: [],
  selectedFacets: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/search/vuex/index.js